<div class="bg-white h-100 text-center">
  <div class="block-top-padding">
    <div class="lock-icon-style">
      <i class="fa fa-lock" aria-hidden="true"></i>
    </div>
    <h2>Not Found</h2>
    <p>You have redirect to wrong page.</p>
    <!-- <p class="color-blue">
      Auto redirecting to previous page in {{ count }} seconds...
    </p> -->
  </div>
</div>
